import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import RibbonActions from '../components/RibbonActions';
import ProductoPicker from '../components/ProductoPicker';
import Productos from './Productos';
import {
  getAlmacenes, crearAlmacen, editarAlmacen, eliminarAlmacen,
  getExistencias, getKardex, getMovimientosInv, registrarMovInv, registrarTraslado,
  getConteos, getConteo, crearConteo, guardarConteo, aplicarConteo, eliminarConteo,
  getLotes, entradaLote, salidaLote, getSeriales, entradaSeriales, salidaSerial,
} from '../services/api';

const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO', { maximumFractionDigits: 0 });
const num = (n) => Number(n || 0).toLocaleString('es-CO', { maximumFractionDigits: 3 });
const fdate = (d) => d ? new Date(d + (String(d).length <= 10 ? 'T00:00:00' : '')).toLocaleDateString('es-CO') : '—';
const TIPO_COLOR = { entrada: '#10b981', salida: '#ef4444', ajuste: '#f59e0b', traslado: '#8b5cf6' };
const TABS_INV = ['productos', 'existencias', 'movimientos', 'lotes', 'seriales', 'fisico', 'almacenes', 'kardex'];
const TITULOS = {
  productos:   { h1: 'Productos',        sub: 'Catálogo de productos y servicios' },
  existencias: { h1: 'Existencias',      sub: 'Stock por almacén y su valorización' },
  movimientos: { h1: 'Movimientos',      sub: 'Entradas, salidas, ajustes y traslados' },
  lotes:       { h1: 'Lotes',            sub: 'Control de lotes y vencimientos' },
  seriales:    { h1: 'Seriales',         sub: 'Control de números de serie' },
  fisico:      { h1: 'Inventario físico', sub: 'Conteos y ajustes de inventario' },
  almacenes:   { h1: 'Almacenes',        sub: 'Bodegas y centros de almacenamiento' },
  kardex:      { h1: 'Kardex',           sub: 'Movimientos y saldo por producto' },
};

export default function Inventario() {
  const [sp] = useSearchParams();
  const tab = TABS_INV.includes(sp.get('tab')) ? sp.get('tab') : 'existencias';
  const [prodCount, setProdCount] = useState(null);
  const [almacenes, setAlmacenes] = useState([]);
  const [existencias, setExistencias] = useState([]);
  const [movs, setMovs] = useState([]);
  const [filtroAlm, setFiltroAlm] = useState('');
  const [q, setQ] = useState('');
  const [modal, setModal] = useState(null); // 'mov' | 'traslado' | 'almacen'
  const [msg, setMsg] = useState(null);

  const loadAlm = () => getAlmacenes().then(r => setAlmacenes(r.data)).catch(() => {});
  const loadEx = () => getExistencias({ almacen_id: filtroAlm || undefined, q: q || undefined }).then(r => setExistencias(r.data)).catch(() => {});
  const loadMovs = () => getMovimientosInv().then(r => setMovs(r.data)).catch(() => {});
  useEffect(() => { loadAlm(); }, []);
  useEffect(() => { if (tab === 'existencias') loadEx(); if (tab === 'movimientos') loadMovs(); /* eslint-disable-next-line */ }, [tab, filtroAlm]);
  const flash = (ok, t) => { setMsg({ ok, t }); setTimeout(() => setMsg(null), 5000); };

  const refrescar = () => { loadAlm(); loadEx(); loadMovs(); };

  return (
    <div>
      <div style={s.header}><div><h1 style={s.h1}>{TITULOS[tab].h1}</h1><p style={s.sub}>{TITULOS[tab].sub}{tab === 'productos' && prodCount != null ? ` · ${prodCount} productos` : ''}</p></div>
        <RibbonActions><div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {tab === 'existencias' && (
            <>
              <select style={{ ...s.input, width: 200 }} value={filtroAlm} onChange={e => setFiltroAlm(e.target.value)}>
                <option value="">Todos los almacenes</option>
                {almacenes.map(a => <option key={a.id} value={a.id}>{a.nombre}</option>)}
              </select>
              <input style={{ ...s.input, width: 200 }} placeholder="Buscar producto…" value={q} onChange={e => setQ(e.target.value)} onKeyDown={e => e.key === 'Enter' && loadEx()} />
              <button style={s.btnSecondary} onClick={loadEx}>Buscar</button>
            </>
          )}
          {(tab === 'existencias' || tab === 'movimientos') && (
            <>
              <button style={s.btnSecondary} onClick={() => setModal('traslado')} disabled={almacenes.length < 2}>⇄ Traslado</button>
              <button style={s.btnPrimary} onClick={() => setModal('mov')}>+ Movimiento</button>
            </>
          )}
        </div></RibbonActions>
      </div>
      {msg && <div style={{ ...s.msg, ...(msg.ok ? s.msgOk : s.msgErr) }}>{msg.ok ? '✅ ' : '❌ '}{msg.t}</div>}

      {tab === 'existencias' && (
        <>
          <div style={s.card}><table style={s.table}>
            <thead><tr>{['Producto', 'Código', 'Almacén', 'Cantidad', 'Costo prom.', 'Valor'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
            <tbody>
              {existencias.length === 0 && <tr><td colSpan={6} style={s.empty}>Sin existencias. Registra una entrada para empezar.</td></tr>}
              {existencias.map(e => (
                <tr key={e.id}>
                  <td style={{ ...s.td, color: '#e2e8f0' }}>{e.producto}</td>
                  <td style={s.td}>{e.codigo || '—'}</td>
                  <td style={s.td}>{e.almacen}</td>
                  <td style={{ ...s.td, fontWeight: 700, color: Number(e.cantidad) < 0 ? '#ef4444' : '#e2e8f0' }}>{num(e.cantidad)} {e.unidad}</td>
                  <td style={s.td}>{fmt(e.costo_promedio)}</td>
                  <td style={{ ...s.td, fontWeight: 700 }}>{fmt(e.valor)}</td>
                </tr>
              ))}
            </tbody>
          </table></div>
        </>
      )}

      {tab === 'movimientos' && (
        <div style={s.card}><table style={s.table}>
          <thead><tr>{['Fecha', 'Tipo', 'Producto', 'Almacén', 'Cantidad', 'Costo unit.', 'Saldo', 'Ref.'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
          <tbody>
            {movs.length === 0 && <tr><td colSpan={8} style={s.empty}>Sin movimientos.</td></tr>}
            {movs.map(m => (
              <tr key={m.id}>
                <td style={s.td}>{fdate(m.fecha)}</td>
                <td style={s.td}><span style={{ ...s.chip, background: (TIPO_COLOR[m.tipo] || '#64748b') + '22', color: TIPO_COLOR[m.tipo] || '#94a3b8' }}>{m.tipo}</span></td>
                <td style={{ ...s.td, color: '#e2e8f0' }}>{m.producto}</td>
                <td style={s.td}>{m.almacen}{m.almacen_destino ? ` → ${m.almacen_destino}` : ''}</td>
                <td style={{ ...s.td, fontWeight: 700, color: Number(m.cantidad) < 0 ? '#ef4444' : '#10b981' }}>{Number(m.cantidad) > 0 ? '+' : ''}{num(m.cantidad)}</td>
                <td style={s.td}>{fmt(m.costo_unitario)}</td>
                <td style={s.td}>{num(m.saldo_cantidad)}</td>
                <td style={s.td}>{m.referencia || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table></div>
      )}

      {tab === 'productos' && <Productos embedded onCount={setProdCount} />}
      {tab === 'lotes' && <Lotes almacenes={almacenes} flash={flash} onDone={refrescar} />}
      {tab === 'seriales' && <Seriales almacenes={almacenes} flash={flash} onDone={refrescar} />}
      {tab === 'fisico' && <InventarioFisico almacenes={almacenes} flash={flash} onAplicado={refrescar} />}
      {tab === 'almacenes' && <Almacenes almacenes={almacenes} reload={loadAlm} flash={flash} />}
      {tab === 'kardex' && <Kardex almacenes={almacenes} />}

      {modal === 'mov' && <MovModal almacenes={almacenes} onClose={() => setModal(null)} onDone={() => { setModal(null); refrescar(); flash(true, 'Movimiento registrado'); }} onErr={t => flash(false, t)} />}
      {modal === 'traslado' && <TrasladoModal almacenes={almacenes} onClose={() => setModal(null)} onDone={() => { setModal(null); refrescar(); flash(true, 'Traslado registrado'); }} onErr={t => flash(false, t)} />}
    </div>
  );
}

// ── Movimiento (entrada/salida/ajuste) ───────────────────────────────────────
function MovModal({ almacenes, onClose, onDone, onErr }) {
  const [f, setF] = useState({ tipo: 'entrada', producto_id: '', producto_nombre: '', almacen_id: almacenes[0]?.id || '', cantidad: '', costo_unitario: '', cantidad_nueva: '', referencia: '', motivo: '' });
  const [saving, setSaving] = useState(false);
  const guardar = async () => {
    if (!f.producto_id) return onErr('Seleccione un producto del catálogo');
    if (!f.almacen_id) return onErr('Seleccione un almacén');
    setSaving(true);
    try { await registrarMovInv(f); onDone(); }
    catch (e) { onErr(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };
  return (
    <Overlay title="Nuevo movimiento" onClose={onClose} onSave={guardar} saving={saving}>
      <Field label="Tipo">
        <select style={s.input} value={f.tipo} onChange={e => setF({ ...f, tipo: e.target.value })}>
          <option value="entrada">Entrada (compra / ingreso)</option>
          <option value="salida">Salida (consumo / venta)</option>
          <option value="ajuste">Ajuste (fijar existencia)</option>
        </select>
      </Field>
      <Field label="Producto (del catálogo)">
        <ProductoPicker style={s.input} value={f.producto_nombre}
          onChangeText={v => setF({ ...f, producto_nombre: v, producto_id: '' })}
          onPick={p => setF({ ...f, producto_id: p.id, producto_nombre: p.nombre, costo_unitario: f.costo_unitario || p.precio_unitario })} />
        {!f.producto_id && f.producto_nombre && <span style={s.hint}>Elige un producto del desplegable (debe existir en el catálogo).</span>}
      </Field>
      <Field label="Almacén">
        <select style={s.input} value={f.almacen_id} onChange={e => setF({ ...f, almacen_id: e.target.value })}>
          <option value="">Seleccionar…</option>
          {almacenes.map(a => <option key={a.id} value={a.id}>{a.nombre}</option>)}
        </select>
      </Field>
      {f.tipo === 'ajuste' ? (
        <Field label="Existencia real (contada)"><input style={s.input} type="number" value={f.cantidad_nueva} onChange={e => setF({ ...f, cantidad_nueva: e.target.value })} /></Field>
      ) : (
        <div style={s.row2}>
          <Field label="Cantidad"><input style={s.input} type="number" value={f.cantidad} onChange={e => setF({ ...f, cantidad: e.target.value })} /></Field>
          {f.tipo === 'entrada' && <Field label="Costo unitario"><input style={s.input} type="number" value={f.costo_unitario} onChange={e => setF({ ...f, costo_unitario: e.target.value })} /></Field>}
        </div>
      )}
      <div style={s.row2}>
        <Field label="Referencia"><input style={s.input} value={f.referencia} placeholder="Ej: FC-123" onChange={e => setF({ ...f, referencia: e.target.value })} /></Field>
        <Field label="Motivo"><input style={s.input} value={f.motivo} onChange={e => setF({ ...f, motivo: e.target.value })} /></Field>
      </div>
    </Overlay>
  );
}

// ── Traslado ─────────────────────────────────────────────────────────────────
function TrasladoModal({ almacenes, onClose, onDone, onErr }) {
  const [f, setF] = useState({ producto_id: '', producto_nombre: '', almacen_id: '', almacen_destino_id: '', cantidad: '', referencia: '' });
  const [saving, setSaving] = useState(false);
  const guardar = async () => {
    if (!f.producto_id) return onErr('Seleccione un producto');
    if (!f.almacen_id || !f.almacen_destino_id) return onErr('Seleccione origen y destino');
    setSaving(true);
    try { await registrarTraslado(f); onDone(); }
    catch (e) { onErr(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };
  return (
    <Overlay title="Traslado entre almacenes" onClose={onClose} onSave={guardar} saving={saving}>
      <Field label="Producto"><ProductoPicker style={s.input} value={f.producto_nombre}
        onChangeText={v => setF({ ...f, producto_nombre: v, producto_id: '' })} onPick={p => setF({ ...f, producto_id: p.id, producto_nombre: p.nombre })} /></Field>
      <div style={s.row2}>
        <Field label="Desde (origen)"><select style={s.input} value={f.almacen_id} onChange={e => setF({ ...f, almacen_id: e.target.value })}><option value="">…</option>{almacenes.map(a => <option key={a.id} value={a.id}>{a.nombre}</option>)}</select></Field>
        <Field label="Hacia (destino)"><select style={s.input} value={f.almacen_destino_id} onChange={e => setF({ ...f, almacen_destino_id: e.target.value })}><option value="">…</option>{almacenes.map(a => <option key={a.id} value={a.id}>{a.nombre}</option>)}</select></Field>
      </div>
      <div style={s.row2}>
        <Field label="Cantidad"><input style={s.input} type="number" value={f.cantidad} onChange={e => setF({ ...f, cantidad: e.target.value })} /></Field>
        <Field label="Referencia"><input style={s.input} value={f.referencia} onChange={e => setF({ ...f, referencia: e.target.value })} /></Field>
      </div>
    </Overlay>
  );
}

// ── Almacenes (CRUD) ─────────────────────────────────────────────────────────
function Almacenes({ almacenes, reload, flash }) {
  const [modal, setModal] = useState(false);
  const [f, setF] = useState({});
  const guardar = async () => {
    if (!f.nombre) return flash(false, 'El nombre es requerido');
    try { f.id ? await editarAlmacen(f.id, f) : await crearAlmacen(f); setModal(false); reload(); flash(true, 'Almacén guardado'); }
    catch (e) { flash(false, e.response?.data?.error || 'Error'); }
  };
  const borrar = async (a) => { if (window.confirm(`¿Eliminar "${a.nombre}"?`)) { await eliminarAlmacen(a.id); reload(); } };
  return (
    <div style={s.card}>
      <RibbonActions><button style={s.btnPrimary} onClick={() => { setF({ es_principal: false }); setModal(true); }}>+ Nuevo almacén</button></RibbonActions>
      <table style={s.table}>
        <thead><tr>{['Nombre', 'Código', 'Responsable', 'Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
        <tbody>
          {almacenes.length === 0 && <tr><td colSpan={4} style={s.empty}>Sin almacenes. Crea el primero.</td></tr>}
          {almacenes.map(a => (
            <tr key={a.id}>
              <td style={{ ...s.td, color: '#e2e8f0' }}>{a.nombre}{a.es_principal && <span style={s.badge}>Principal</span>}</td>
              <td style={s.td}>{a.codigo || '—'}</td>
              <td style={s.td}>{a.responsable || '—'}</td>
              <td style={s.td}><button style={s.link} onClick={() => { setF({ ...a }); setModal(true); }}>Editar</button><button style={{ ...s.link, color: '#fca5a5' }} onClick={() => borrar(a)}>Eliminar</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {modal && (
        <Overlay title={f.id ? 'Editar almacén' : 'Nuevo almacén'} onClose={() => setModal(false)} onSave={guardar}>
          <div style={s.row2}>
            <Field label="Nombre *"><input style={s.input} value={f.nombre || ''} onChange={e => setF({ ...f, nombre: e.target.value })} /></Field>
            <Field label="Código"><input style={s.input} value={f.codigo || ''} onChange={e => setF({ ...f, codigo: e.target.value })} /></Field>
          </div>
          <Field label="Dirección"><input style={s.input} value={f.direccion || ''} onChange={e => setF({ ...f, direccion: e.target.value })} /></Field>
          <Field label="Responsable"><input style={s.input} value={f.responsable || ''} onChange={e => setF({ ...f, responsable: e.target.value })} /></Field>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#cbd5e1', fontSize: 13, marginTop: 6 }}>
            <input type="checkbox" checked={!!f.es_principal} onChange={e => setF({ ...f, es_principal: e.target.checked })} /> Almacén principal</label>
        </Overlay>
      )}
    </div>
  );
}

// ── Kardex ───────────────────────────────────────────────────────────────────
function Kardex({ almacenes }) {
  const [prod, setProd] = useState({ id: '', nombre: '' });
  const [alm, setAlm] = useState('');
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const cargar = async () => {
    if (!prod.id || !alm) return;
    try { const { data } = await getKardex({ producto_id: prod.id, almacen_id: alm }); setRows(data); setLoaded(true); } catch { setRows([]); }
  };
  return (
    <div>
      <RibbonActions><div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <ProductoPicker style={{ ...s.input, minWidth: 220 }} value={prod.nombre} onChangeText={v => setProd({ id: '', nombre: v })} onPick={p => setProd({ id: p.id, nombre: p.nombre })} />
        <select style={{ ...s.input, width: 170 }} value={alm} onChange={e => setAlm(e.target.value)}><option value="">Almacén…</option>{almacenes.map(a => <option key={a.id} value={a.id}>{a.nombre}</option>)}</select>
        <button style={s.btnPrimary} onClick={cargar} disabled={!prod.id || !alm}>Ver kardex</button>
      </div></RibbonActions>
      <div style={s.card}><table style={s.table}>
        <thead><tr>{['Fecha', 'Tipo', 'Entrada', 'Salida', 'Costo unit.', 'Saldo', 'Costo prom.', 'Ref.'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
        <tbody>
          {loaded && rows.length === 0 && <tr><td colSpan={8} style={s.empty}>Sin movimientos para este producto/almacén.</td></tr>}
          {!loaded && <tr><td colSpan={8} style={s.empty}>Elige un producto y un almacén.</td></tr>}
          {rows.map(m => (
            <tr key={m.id}>
              <td style={s.td}>{fdate(m.fecha)}</td>
              <td style={s.td}><span style={{ ...s.chip, background: (TIPO_COLOR[m.tipo] || '#64748b') + '22', color: TIPO_COLOR[m.tipo] || '#94a3b8' }}>{m.tipo}</span></td>
              <td style={{ ...s.td, color: '#10b981' }}>{Number(m.cantidad) > 0 ? num(m.cantidad) : ''}</td>
              <td style={{ ...s.td, color: '#ef4444' }}>{Number(m.cantidad) < 0 ? num(Math.abs(m.cantidad)) : ''}</td>
              <td style={s.td}>{fmt(m.costo_unitario)}</td>
              <td style={{ ...s.td, fontWeight: 700 }}>{num(m.saldo_cantidad)}</td>
              <td style={s.td}>{fmt(m.costo_promedio)}</td>
              <td style={s.td}>{m.referencia || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table></div>
    </div>
  );
}

// ── Lotes ────────────────────────────────────────────────────────────────────
const VENC_COLOR = { vencido: '#ef4444', por_vencer: '#f59e0b', vigente: '#10b981' };
const VENC_LBL = { vencido: 'Vencido', por_vencer: 'Por vencer', vigente: 'Vigente' };
function Lotes({ almacenes, flash, onDone }) {
  const [lotes, setLotes] = useState([]);
  const [modal, setModal] = useState(false);
  const [f, setF] = useState({});
  const load = () => getLotes().then(r => setLotes(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const abrir = () => { setF({ producto_id: '', producto_nombre: '', almacen_id: almacenes[0]?.id || '', lote: '', fecha_vencimiento: '', cantidad: '', costo_unitario: '' }); setModal(true); };
  const guardar = async () => {
    if (!f.producto_id) return flash(false, 'Seleccione producto del catálogo');
    if (!f.almacen_id || !f.lote) return flash(false, 'Almacén y lote son requeridos');
    try { await entradaLote(f); setModal(false); load(); onDone(); flash(true, 'Entrada de lote registrada'); }
    catch (e) { flash(false, e.response?.data?.error || 'Error'); }
  };
  const salida = async (l) => {
    const c = window.prompt(`Salida del lote "${l.lote}" (disponible ${num(l.cantidad)}). ¿Cuánto sale?`);
    if (!c) return;
    try { await salidaLote(l.id, { cantidad: c }); load(); onDone(); flash(true, 'Salida registrada'); }
    catch (e) { flash(false, e.response?.data?.error || 'Error'); }
  };
  return (
    <div>
      <RibbonActions><button style={s.btnPrimary} onClick={abrir}>+ Entrada por lote</button></RibbonActions>
      <div style={s.card}><table style={s.table}>
        <thead><tr>{['Producto', 'Lote', 'Almacén', 'Vence', 'Estado', 'Cantidad', 'Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
        <tbody>
          {lotes.length === 0 && <tr><td colSpan={7} style={s.empty}>Sin lotes. Registra una entrada por lote.</td></tr>}
          {lotes.map(l => (
            <tr key={l.id}>
              <td style={{ ...s.td, color: '#e2e8f0' }}>{l.producto}</td>
              <td style={{ ...s.td, fontWeight: 600 }}>{l.lote}</td>
              <td style={s.td}>{l.almacen}</td>
              <td style={s.td}>{l.fecha_vencimiento ? fdate(l.fecha_vencimiento) : '—'}{l.dias_venc != null && l.estado_venc !== 'vencido' ? ` (${l.dias_venc}d)` : ''}</td>
              <td style={s.td}>{l.estado_venc ? <span style={{ ...s.chip, background: VENC_COLOR[l.estado_venc] + '22', color: VENC_COLOR[l.estado_venc] }}>{VENC_LBL[l.estado_venc]}</span> : '—'}</td>
              <td style={{ ...s.td, fontWeight: 700 }}>{num(l.cantidad)} {l.unidad}</td>
              <td style={s.td}><button style={s.link} onClick={() => salida(l)}>Salida</button></td>
            </tr>
          ))}
        </tbody>
      </table></div>
      {modal && (
        <Overlay title="Entrada por lote" onClose={() => setModal(false)} onSave={guardar}>
          <Field label="Producto"><ProductoPicker style={s.input} value={f.producto_nombre} onChangeText={v => setF({ ...f, producto_nombre: v, producto_id: '' })} onPick={p => setF({ ...f, producto_id: p.id, producto_nombre: p.nombre, costo_unitario: f.costo_unitario || p.precio_unitario })} /></Field>
          <Field label="Almacén"><select style={s.input} value={f.almacen_id} onChange={e => setF({ ...f, almacen_id: e.target.value })}><option value="">…</option>{almacenes.map(a => <option key={a.id} value={a.id}>{a.nombre}</option>)}</select></Field>
          <div style={s.row2}>
            <Field label="Lote"><input style={s.input} value={f.lote} placeholder="Ej: L-2026-08" onChange={e => setF({ ...f, lote: e.target.value })} /></Field>
            <Field label="Vencimiento"><input style={s.input} type="date" value={f.fecha_vencimiento} onChange={e => setF({ ...f, fecha_vencimiento: e.target.value })} /></Field>
          </div>
          <div style={s.row2}>
            <Field label="Cantidad"><input style={s.input} type="number" value={f.cantidad} onChange={e => setF({ ...f, cantidad: e.target.value })} /></Field>
            <Field label="Costo unitario"><input style={s.input} type="number" value={f.costo_unitario} onChange={e => setF({ ...f, costo_unitario: e.target.value })} /></Field>
          </div>
        </Overlay>
      )}
    </div>
  );
}

// ── Seriales ─────────────────────────────────────────────────────────────────
function Seriales({ almacenes, flash, onDone }) {
  const [seriales, setSeriales] = useState([]);
  const [fEstado, setFEstado] = useState('disponible');
  const [q, setQ] = useState('');
  const [modal, setModal] = useState(false);
  const [f, setF] = useState({});
  const load = () => getSeriales({ estado: fEstado || undefined, q: q || undefined }).then(r => setSeriales(r.data)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [fEstado]);
  const abrir = () => { setF({ producto_id: '', producto_nombre: '', almacen_id: almacenes[0]?.id || '', serialesTxt: '', costo_unitario: '', referencia: '' }); setModal(true); };
  const guardar = async () => {
    if (!f.producto_id) return flash(false, 'Seleccione producto del catálogo');
    if (!f.almacen_id) return flash(false, 'Seleccione almacén');
    const seriales = (f.serialesTxt || '').split(/[\n,;]+/).map(x => x.trim()).filter(Boolean);
    if (!seriales.length) return flash(false, 'Ingrese los números de serie (uno por línea)');
    try { const { data } = await entradaSeriales({ producto_id: f.producto_id, almacen_id: f.almacen_id, seriales, costo_unitario: f.costo_unitario, referencia: f.referencia }); setModal(false); load(); onDone(); flash(true, `${data.registrados} serial(es) registrados`); }
    catch (e) { flash(false, e.response?.data?.error || 'Error'); }
  };
  const salida = async (ser) => { if (!window.confirm(`¿Dar salida al serial ${ser.serial}?`)) return; try { await salidaSerial(ser.id, {}); load(); onDone(); flash(true, 'Salida registrada'); } catch (e) { flash(false, e.response?.data?.error || 'Error'); } };
  return (
    <div>
      <RibbonActions><div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <select style={{ ...s.input, width: 150 }} value={fEstado} onChange={e => setFEstado(e.target.value)}><option value="disponible">Disponibles</option><option value="salida">Con salida</option><option value="">Todos</option></select>
        <input style={{ ...s.input, width: 200 }} placeholder="Buscar serial o producto…" value={q} onChange={e => setQ(e.target.value)} onKeyDown={e => e.key === 'Enter' && load()} />
        <button style={s.btnSecondary} onClick={load}>Buscar</button>
        <button style={s.btnPrimary} onClick={abrir}>+ Entrada con seriales</button>
      </div></RibbonActions>
      <div style={s.card}><table style={s.table}>
        <thead><tr>{['Serial', 'Producto', 'Almacén', 'Estado', 'Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
        <tbody>
          {seriales.length === 0 && <tr><td colSpan={5} style={s.empty}>Sin seriales.</td></tr>}
          {seriales.map(ser => (
            <tr key={ser.id}>
              <td style={{ ...s.td, fontWeight: 600, fontFamily: 'ui-monospace' }}>{ser.serial}</td>
              <td style={{ ...s.td, color: '#e2e8f0' }}>{ser.producto}</td>
              <td style={s.td}>{ser.almacen}</td>
              <td style={s.td}><span style={{ ...s.chip, background: ser.estado === 'disponible' ? '#16653422' : '#7f1d1d22', color: ser.estado === 'disponible' ? '#34d399' : '#fca5a5' }}>{ser.estado}</span></td>
              <td style={s.td}>{ser.estado === 'disponible' && <button style={s.link} onClick={() => salida(ser)}>Salida</button>}</td>
            </tr>
          ))}
        </tbody>
      </table></div>
      {modal && (
        <Overlay title="Entrada con seriales" onClose={() => setModal(false)} onSave={guardar}>
          <Field label="Producto"><ProductoPicker style={s.input} value={f.producto_nombre} onChangeText={v => setF({ ...f, producto_nombre: v, producto_id: '' })} onPick={p => setF({ ...f, producto_id: p.id, producto_nombre: p.nombre, costo_unitario: f.costo_unitario || p.precio_unitario })} /></Field>
          <div style={s.row2}>
            <Field label="Almacén"><select style={s.input} value={f.almacen_id} onChange={e => setF({ ...f, almacen_id: e.target.value })}><option value="">…</option>{almacenes.map(a => <option key={a.id} value={a.id}>{a.nombre}</option>)}</select></Field>
            <Field label="Costo unitario"><input style={s.input} type="number" value={f.costo_unitario} onChange={e => setF({ ...f, costo_unitario: e.target.value })} /></Field>
          </div>
          <Field label="Números de serie (uno por línea)"><textarea style={{ ...s.input, height: 'auto', minHeight: 100, padding: '8px 11px', resize: 'vertical', fontFamily: 'ui-monospace' }} value={f.serialesTxt} placeholder={'SN-001\nSN-002\nSN-003'} onChange={e => setF({ ...f, serialesTxt: e.target.value })} /></Field>
          <Field label="Referencia"><input style={s.input} value={f.referencia} placeholder="Ej: FC-123" onChange={e => setF({ ...f, referencia: e.target.value })} /></Field>
        </Overlay>
      )}
    </div>
  );
}

// ── Inventario físico (conteos) ──────────────────────────────────────────────
function InventarioFisico({ almacenes, flash, onAplicado }) {
  const [conteos, setConteos] = useState([]);
  const [sel, setSel] = useState(null);   // conteo detalle
  const [items, setItems] = useState([]);
  const [nuevoAlm, setNuevoAlm] = useState('');
  const [saving, setSaving] = useState(false);

  const load = () => getConteos().then(r => setConteos(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const abrir = async (c) => {
    try { const { data } = await getConteo(c.id); setSel(data); setItems(data.items.map(i => ({ ...i, cantidad_contada: i.cantidad_contada ?? '' }))); }
    catch { flash(false, 'No se pudo abrir'); }
  };
  const crear = async () => {
    if (!nuevoAlm) return flash(false, 'Seleccione un almacén');
    try { const { data } = await crearConteo({ almacen_id: nuevoAlm }); load(); abrir(data); }
    catch (e) { flash(false, e.response?.data?.error || 'Error'); }
  };
  const setContada = (id, v) => setItems(its => its.map(i => i.id === id ? { ...i, cantidad_contada: v } : i));
  const guardar = async () => {
    setSaving(true);
    try { await guardarConteo(sel.id, { items: items.map(i => ({ producto_id: i.producto_id, cantidad_contada: i.cantidad_contada })) }); flash(true, 'Conteo guardado'); }
    catch (e) { flash(false, e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };
  const aplicar = async () => {
    if (!window.confirm('Aplicar el conteo generará ajustes de inventario por cada diferencia. ¿Continuar?')) return;
    setSaving(true);
    try { await guardarConteo(sel.id, { items: items.map(i => ({ producto_id: i.producto_id, cantidad_contada: i.cantidad_contada })) });
      const { data } = await aplicarConteo(sel.id); flash(true, `Conteo aplicado — ${data.ajustes} ajuste(s) generados`); setSel(null); load(); onAplicado(); }
    catch (e) { flash(false, e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };
  const borrar = async (c) => { if (window.confirm('¿Eliminar este conteo?')) { await eliminarConteo(c.id); load(); } };

  if (sel) {
    const aplicado = sel.estado === 'aplicado';
    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <div><button style={s.link} onClick={() => setSel(null)}>← Volver</button>
            <span style={{ color: '#e2e8f0', fontWeight: 600, marginLeft: 8 }}>Conteo · {sel.almacen} · {fdate(sel.fecha)}</span>
            {aplicado && <span style={{ ...s.chip, background: '#16653422', color: '#34d399', marginLeft: 8 }}>Aplicado</span>}
          </div>
          {!aplicado && <div style={{ display: 'flex', gap: 8 }}>
            <button style={s.btnSecondary} onClick={guardar} disabled={saving}>Guardar</button>
            <button style={s.btnPrimary} onClick={aplicar} disabled={saving}>Aplicar ajustes</button>
          </div>}
        </div>
        <div style={s.card}><table style={s.table}>
          <thead><tr>{['Producto', 'Código', 'Sistema', 'Contado', 'Diferencia'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5} style={s.empty}>Este almacén no tiene existencias registradas para contar.</td></tr>}
            {items.map(it => {
              const dif = it.cantidad_contada === '' || it.cantidad_contada == null ? null : Number(it.cantidad_contada) - Number(it.cantidad_sistema);
              return (
                <tr key={it.id}>
                  <td style={{ ...s.td, color: '#e2e8f0' }}>{it.producto}</td>
                  <td style={s.td}>{it.codigo || '—'}</td>
                  <td style={s.td}>{num(it.cantidad_sistema)} {it.unidad}</td>
                  <td style={s.td}>{aplicado ? num(it.cantidad_contada) : <input style={{ ...s.input, height: 32, width: 110 }} type="number" value={it.cantidad_contada} onChange={e => setContada(it.id, e.target.value)} />}</td>
                  <td style={{ ...s.td, fontWeight: 700, color: dif == null ? '#64748b' : dif === 0 ? '#64748b' : dif > 0 ? '#10b981' : '#ef4444' }}>{dif == null ? '—' : (dif > 0 ? '+' : '') + num(dif)}</td>
                </tr>
              );
            })}
          </tbody>
        </table></div>
        <p style={s.hint2}>Escribe lo que contaste físicamente. Al "Aplicar ajustes", el sistema genera un movimiento de ajuste por cada diferencia y deja la existencia igual a lo contado.</p>
      </div>
    );
  }

  return (
    <div>
      <RibbonActions><div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <select style={{ ...s.input, width: 220 }} value={nuevoAlm} onChange={e => setNuevoAlm(e.target.value)}><option value="">Almacén a contar…</option>{almacenes.map(a => <option key={a.id} value={a.id}>{a.nombre}</option>)}</select>
        <button style={s.btnPrimary} onClick={crear} disabled={!nuevoAlm}>+ Nuevo conteo</button>
      </div></RibbonActions>
      <div style={s.card}><table style={s.table}>
        <thead><tr>{['Fecha', 'Almacén', 'Ítems', 'Estado', 'Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
        <tbody>
          {conteos.length === 0 && <tr><td colSpan={5} style={s.empty}>Sin conteos. Crea uno para hacer inventario físico.</td></tr>}
          {conteos.map(c => (
            <tr key={c.id}>
              <td style={s.td}>{fdate(c.fecha)}</td>
              <td style={{ ...s.td, color: '#e2e8f0' }}>{c.almacen}</td>
              <td style={s.td}>{c.items}</td>
              <td style={s.td}><span style={{ ...s.chip, background: c.estado === 'aplicado' ? '#16653422' : '#f59e0b22', color: c.estado === 'aplicado' ? '#34d399' : '#f59e0b' }}>{c.estado}</span></td>
              <td style={s.td}><button style={s.link} onClick={() => abrir(c)}>{c.estado === 'aplicado' ? 'Ver' : 'Contar'}</button>{c.estado === 'abierto' && <button style={{ ...s.link, color: '#fca5a5' }} onClick={() => borrar(c)}>Eliminar</button>}</td>
            </tr>
          ))}
        </tbody>
      </table></div>
    </div>
  );
}

// ── Helpers UI ───────────────────────────────────────────────────────────────
const Field = ({ label, children }) => <div style={s.field}><label style={s.label}>{label}</label>{children}</div>;
function Overlay({ title, children, onClose, onSave, saving }) {
  return (
    <div style={s.overlay}><div style={s.modal}>
      <div style={s.modalHeader}><h2 style={s.modalTitle}>{title}</h2><button style={s.closeBtn} onClick={onClose}>✕</button></div>
      <div style={s.modalBody}>{children}</div>
      <div style={s.modalFooter}><button style={s.btnSecondary} onClick={onClose}>Cancelar</button><button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} disabled={saving} onClick={onSave}>{saving ? 'Guardando…' : 'Guardar'}</button></div>
    </div></div>
  );
}

const s = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 },
  h1: { fontSize: 24, fontWeight: 700, color: '#f1f5f9', margin: 0 },
  sub: { color: '#64748b', fontSize: 14, margin: '4px 0 0' },
  btnPrimary: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  btnSecondary: { background: '#334155', color: '#cbd5e1', border: 'none', borderRadius: 8, padding: '9px 16px', fontSize: 13, cursor: 'pointer' },
  msg: { padding: '10px 14px', borderRadius: 8, marginBottom: 14, fontSize: 13 },
  msgOk: { background: '#052e1a', border: '1px solid #16a34a', color: '#86efac' },
  msgErr: { background: '#450a0a', border: '1px solid #b91c1c', color: '#fca5a5' },
  tabs: { display: 'flex', gap: 8, marginBottom: 16, borderBottom: '1px solid #334155', flexWrap: 'wrap' },
  tab: { background: 'none', border: 'none', color: '#94a3b8', padding: '10px 16px', fontSize: 14, cursor: 'pointer', borderBottom: '2px solid transparent' },
  tabOn: { color: '#f1f5f9', borderBottom: '2px solid #4f46e5', fontWeight: 600 },
  barra: { display: 'flex', gap: 10, marginBottom: 14, flexWrap: 'wrap' },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { background: '#0f172a', color: '#94a3b8', fontSize: 11, textTransform: 'uppercase', letterSpacing: '.5px', padding: '10px 14px', textAlign: 'left' },
  td: { padding: '9px 14px', color: '#cbd5e1', borderBottom: '1px solid #1a2332' },
  empty: { padding: 24, textAlign: 'center', color: '#64748b' },
  chip: { fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 4, textTransform: 'capitalize' },
  badge: { marginLeft: 8, fontSize: 10, color: '#34d399', border: '1px solid #34d39955', borderRadius: 4, padding: '1px 6px' },
  link: { background: 'none', border: 'none', color: '#60a5fa', cursor: 'pointer', fontSize: 13, padding: 0, marginRight: 12 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
  modal: { background: '#1e293b', borderRadius: 16, width: '94%', maxWidth: 560, maxHeight: '92vh', display: 'flex', flexDirection: 'column', border: '1px solid #334155' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #334155' },
  modalTitle: { color: '#f1f5f9', fontSize: 18, fontWeight: 700, margin: 0 },
  closeBtn: { background: 'none', border: 'none', color: '#94a3b8', fontSize: 20, cursor: 'pointer' },
  modalBody: { padding: '16px 20px', overflowY: 'auto' },
  modalFooter: { display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '14px 20px', borderTop: '1px solid #334155' },
  row2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 },
  field: { display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 12 },
  label: { color: '#94a3b8', fontSize: 12 },
  hint: { color: '#f59e0b', fontSize: 11, marginTop: 3 },
  hint2: { color: '#64748b', fontSize: 12, marginTop: 10 },
  input: { background: '#0f172a', border: '1px solid #334155', borderRadius: 8, height: 40, padding: '0 11px', color: '#f1f5f9', fontSize: 13, width: '100%', boxSizing: 'border-box' },
};
